import { Sidebar } from "@components/sidebar/index";
import { cartState } from "@recoil/atoms";
import { House, ShoppingBag, ShoppingCart, Store } from 'lucide-react';
import React, { useState } from "react";
import { useRecoilValue } from "recoil";

type Props = {
    setOpenTabs?: Function
    showInDesktop?: boolean
    maxWidth?: string
    openTabs?: string
}


export const NavbarV2: React.FC<Props> = ({ setOpenTabs, showInDesktop = false, maxWidth, openTabs }) => {
    const [isShowSidebar, setIsShowSidebar] = useState(false);
    const cart = useRecoilValue(cartState);

    return (
        <>
            <div className={`z-[100] bg-neutral-50 fixed h-16 p-0 flex justify-center bottom-0 left-0 right-0 ${showInDesktop ? "" : "md:hidden"}`}>
                <ul className={`flex flex-row ${maxWidth?.length > 0 ? maxWidth : ""} justify-between grow py-2 px-8`}>
                    <li className={`nav-item ${openTabs === "home" ? "text-brand-500" : "text-neutral-900"} px-1 flex items-center select-none`}>
                        <span className="flex flex-col items-center" onClick={() => { setOpenTabs("home") }}>
                            <House size="1.8em" /><p className="text-[11px]">Home</p>
                        </span>
                    </li>
                    <li className={`nav-item ${openTabs === "categories" ? "text-brand-500" : "text-neutral-900"} px-1 flex items-center select-none`}>
                        <span className="flex flex-col items-center" onClick={() => { setOpenTabs("categories") }}>
                            <Store size="1.8em" /><p className="text-[11px]">Categories</p>
                        </span>
                    </li>
                    <li className={`nav-item ${openTabs === "cart" ? "text-brand-500" : "text-neutral-900"} px-1 flex items-center select-none relative`}>
                        <span className="flex flex-col items-center" onClick={() => { setOpenTabs("cart") }}>
                            <ShoppingCart size="1.8em" /><p className="text-[11px]">Cart</p>
                        </span>
                        <span
                            className={
                                cart?.size > 0
                                    ? `absolute top-0 -right-2 flex justify-center items-center text-xs text-neutral-50 bg-success-500 rounded-full h-5 w-5`
                                    : 'hidden'
                            }
                        >
                            {cart.size}
                        </span>
                    </li>
                    <li className={`nav-item ${openTabs === "orders" ? "text-brand-500" : "text-neutral-900"} px-1 flex items-center select-none`}>
                        <span className="flex flex-col items-center" onClick={() => { setOpenTabs("orders") }}>
                            <ShoppingBag size="1.8em" /><p className="text-[11px]">My Orders</p>
                        </span>
                    </li>
                </ul>
            </div>
            {isShowSidebar && <div className="flex flex-col items-center justify-center py-2">
                <Sidebar isShowSidebar={isShowSidebar} />
            </div>}
        </>
    );
};
